export default __webpack_public_path__ + "static/media/hm-evo-img.61c163d2.webp";